import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { maintenancePeriods } from '../maintenance.config';

@Injectable({
    providedIn: 'root'
})
export class MaintenanceGuard implements CanActivate {
    constructor(private router: Router) {}

    canActivate(): boolean | UrlTree {
        const currentTime = new Date();

        if (this.isMaintenanceTime(currentTime)) {
            return this.router.parseUrl('/maintenance');
        }

        return true;
    }

    private isMaintenanceTime(currentTime: Date): boolean {
        return maintenancePeriods.some(period => {
            const startTime = new Date(period.start);
            const endTime = new Date(period.end);
            return currentTime >= startTime && currentTime <= endTime;
        });
    }
}
